import { httpClient } from "@services/api/httpClient";

const logoutApi = async () => {
    const response = await httpClient.post("/auth/logout", {}, {});
    return response;
}

export default logoutApi;